import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { debounceTime, Subject, takeUntil } from 'rxjs';
import { CollaborationService } from '../../services/collaboration.service';
import { EmailWeavyData, ReferralDetails, SpaceDataInQueryPrams, WeavyConfigObj, WeavyData } from '../../interfaces/space.interface';
import { debounce } from 'lodash';
import { MatTabGroup, MatTab } from '@angular/material/tabs';
import { PostsComponent } from '../posts/posts.component';
import { ActivityDocumentsComponent } from '../activity-documents/activity-documents.component';
import { PolicyDocumentsComponent } from '../policy-documents/policy-documents.component';
import { NoRequiredDateComponent } from '../../no-required-date/no-required-date.component';
import { SpinnerComponent } from '../../components/spinner/spinner.component';

@Component({
    selector: 'app-collaboration',
    templateUrl: './collaboration.component.html',
    styleUrl: './collaboration.component.scss',
    imports: [MatTabGroup, MatTab, PostsComponent, ActivityDocumentsComponent, PolicyDocumentsComponent, NoRequiredDateComponent, SpinnerComponent]
})
export class CollaborationComponent implements OnInit, OnDestroy {
  destroy$: Subject<boolean> = new Subject<boolean>();
  weavyData: EmailWeavyData = {
    userEmail: "Audrey.Reidy@chubb.com"
  };
  weavyConfigObj: WeavyConfigObj | null = null;
  apiFailureOnWeavyData = false;
  showLoader = true;
  constructor(private activatedRoute: ActivatedRoute, private collaborationService: CollaborationService) {

  }
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  ngOnInit(): void {
    this.collaborationService.isApplicationRunningOnOnItSystem = true;
    this.activatedRoute.queryParams.pipe(
      debounceTime(10),
      takeUntil(this.destroy$)
    ).subscribe((params: any) => {
      if (params.spaceId) {
        this.getSynergyConfigurations(params);
      }
    });
  }

  getSynergyConfigurations(spaceDataInQueryPrams: SpaceDataInQueryPrams) {
    this.collaborationService.getWeavyOnItData(spaceDataInQueryPrams.spaceId)
      .subscribe({
        next: (res: any) => {
          this.showLoader = false;
          const clientInfo: ReferralDetails = {
            ...res.data,
            policy: res.data.policyTermName,
            policyKey: res.data.transactionKey
          };
          let name = this.getProductName(clientInfo);
          let weavySpace = '';
          let weavyPostsAppKey = '';
          let weavyDocsAppKey = '';
          let trackerNumber = '';
          let policyWeavySpace = '';
          let policyWeavyAppKey = '';
          let referralId = clientInfo.referralDocumentId;

          if (clientInfo.hubDynamicsPolicyTermId && clientInfo.hubActivityId) {
            weavySpace = `${clientInfo.hubActivityId}:${clientInfo.hubDynamicsPolicyTermId}`;
            weavyPostsAppKey = `TaskPost-${clientInfo.hubActivityId}`;
            weavyDocsAppKey = `Task-${clientInfo.hubActivityId}`;
            policyWeavySpace = clientInfo.hubDynamicsPolicyTermId;
            policyWeavyAppKey = `Policy-${clientInfo.hubDynamicsPolicyTermId}`;
            trackerNumber = clientInfo.policyKey;
          } else {
            weavySpace = `${referralId}:${clientInfo.policyKey}`;
            weavyPostsAppKey = `TaskPost-${referralId}`;
            weavyDocsAppKey = `Task-${referralId}`;
            policyWeavySpace = clientInfo.policyKey;
            policyWeavyAppKey = `Policy-${clientInfo.policyKey}`;
            trackerNumber = clientInfo.policyKey;
          }
          let appName = name;
          if (clientInfo.synergyActivityType?.toLowerCase() === 'draftingportal') {
            appName += clientInfo.onItId ? `~Request#~${clientInfo.onItId}~Drafting Portal~${clientInfo.onItGuid}` : '';
          } else if (clientInfo.synergyActivityType?.toLowerCase() === 'laser') {
            appName += clientInfo.onItId ? `~Request#~${clientInfo.onItId}~LASER~${clientInfo.onItGuid}` : '';
          } else if (clientInfo.synergyActivityType?.toLowerCase() === 'climate') {            
            appName += clientInfo.onItId ? `~Request#~${clientInfo.onItId}~Climate~${clientInfo.onItGuid}` : '';
          }

          let weavyConfigObj: any = {
            "spaceName": name,
            "appName": `${clientInfo.sequenceId}_${appName}`,
            "userEmail": this.collaborationService.userEmail,
            trackerReferenceNumber: trackerNumber,
            policySpaceName: name,
            draft: res.data.draft
            //"isMobileScreen": false
          }
          this.weavyConfigObj = {
            posts: {
              ...weavyConfigObj,
              tab: "posts",
              spaceKey: weavySpace,
              appKey: weavyPostsAppKey,
            },
            documents: {
              ...weavyConfigObj,
              tab: "referral",
              spaceKey: weavySpace,
              appKey: weavyDocsAppKey,
            },
            policyDocuments: {
              ...weavyConfigObj,
              tab: "policy",
              appName: weavyConfigObj.spaceName,
              spaceKey: policyWeavySpace,
              appKey: policyWeavyAppKey,
            }
          }
        },
        error: (err: any) => {
          this.apiFailureOnWeavyData = true;
          this.showLoader = false;
          this.collaborationService.displayErrorMessage(err, 'Error while retrieving the space details. Please try after some time.');
        }
      })
  }

  getProductName = (clientInfo: ReferralDetails): string => {
    let name = `${clientInfo.policy}~${clientInfo.clientName}`;
    if (!clientInfo.groupFlow) {
      name = `${clientInfo.policy?.split('|')[0].trim()}~${clientInfo.policy?.split('|')[1].trim()}~${new Date(
        clientInfo.policy.split('|')[3].split(' - ')[0]
      ).getFullYear()}`;
    }
    return name;
  };

  selectedItem($event: any) {
    console.log($event);
  }
}
